import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import share from '@devices/settings/device_settings/share.js';
import energy_category from '@devices/settings/device_settings/energy_category.js';

export default {
	name: 'shellyem3',
	friendly_name: 'EM3',
	family: 'emeter',
	isPM: true,
	modes: {
		emeter: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			phases: 3,
			settings: [
				timer,
				schedule,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				{
					title: 'safety',
					components: [
						{
							title: 'max_power_protection',
							component: 'max_power_protection_em3',
						},
					],
				},
				{
					title: 'application_settings',
					components: [
						{ title: 'ai_model', component: 'ai_model' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						energy_category,
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{
							title: 'consumption_indicator',
							component: 'consumption_indicator',
							min_ver: '1.12.0',
						},
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{
							title: 'transformer_calibration',
							component: 'transformer_calibration',
							min_ver: '1.12.0',
						},
						{
							title: 'range_extenders',
							component: 'range_extenders',
							min_ver: '1.12.0',
						},
						{
							title: 'neutral_mismatch',
							component: 'neutral_mismatch',
							min_ver: '1.12.0',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'erase_data', component: 'erase_data' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
